import React, { useEffect } from "react";
import { Form, InputNumber } from "antd";

const Number = ({ state = {}, keyName, min = 0, max, readOnly, style = {}, ...props }) => {
  const { data, form, rules, onChange } = state;

  // Sync antd form with state
  useEffect(() => {
    form?.setFieldsValue({ [keyName]: data });
  }, [data, keyName]);

  return (
    <Form form={form} style={{ width: "100%", ...style }}>
      <Form.Item name={keyName} rules={rules}>
        <InputNumber
          size="large"
          min={min}
          max={max}
          step={1}
          value={data}
          style={{ fontSize: style?.inputFontSize || "16px", width: "100%" }}
          onChange={onChange}
          readOnly={readOnly}
          {...props}
        />
      </Form.Item>
    </Form>
  );
};

export default Number;
